import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, computed, inject, input, output } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe } from '@mitsubishi/core';
import {StatisticData, StatisticOption} from '@mitsubishi/project/data-access';
import { DialogService } from '@mitsubishi/ui/dialog';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { StatisticDataDialogComponent } from '../statistic-data-dialog/statistic-data-dialog.component';
import {KeysPipe, ValuesPipe} from "@mitsubishi/shared/ui";


@Component({
  selector: 'apm-statistics-data-icons',
  templateUrl: './statistics-data-icons.component.html',
  styleUrls: ['./statistics-data-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FaIconComponent, MatTooltip, ApmTranslatePipe, KeysPipe, ValuesPipe],
})
export class StatisticsDataIconsComponent {
  #dialogService = inject(DialogService);
  disabled = input<boolean>(false);
  statisticData = input<Record<string, StatisticOption> | null>(null);

  statisticClick = output<void>();

  projectId?: string;
  selectionId?: string;

  onStatisticClick(): void {
    if (this.disabled()) {
      return;
    }
    this.#dialogService
      .openDialog(StatisticDataDialogComponent, 'xl', this.statisticData())
      .afterClosed()
      .pipe(take(1))
      .subscribe();
  }
}
